import { message, notification } from "antd";
import MessageContext from "contexts/MessageContext";

export const MessageProvider = ({ children }) => {
  const [messageApi, messageContextHolder] = message.useMessage();
  const [notificationApi, notificationContextHolder] =
    notification.useNotification();

  const customMessage = {
    success: (content, duration = 3, maxCount = 1) => {
      if (maxCount === 1) {
        messageApi.destroy();
      }
      messageApi.open({
        type: "success",
        content: content,
        duration: duration,
      });
    },
    error: (content, duration = 3, maxCount = 1) => {
      if (maxCount === 1) {
        messageApi.destroy();
      }
      messageApi.open({
        type: "error",
        content: content,
        duration: duration,
      });
    },
    warning: (content, duration = 3, maxCount = 1) => {
      if (maxCount === 1) {
        messageApi.destroy();
      }
      messageApi.open({
        type: "warning",
        content: content,
        duration: duration,
      });
    },
    info: (content, duration = 3, maxCount = 1) => {
      if (maxCount === 1) {
        messageApi.destroy();
      }
      messageApi.open({
        type: "info",
        content: content,
        duration: duration,
      });
    },
    loading: (content, duration = 3, maxCount = 1) => {
      if (maxCount === 1) {
        messageApi.destroy();
      }
      return messageApi.open({
        type: "loading",
        content: content,
        duration: duration,
      });
    },

    destroy: () => {
      messageApi.destroy();
    },
  };

  const customNotification = {
    success: (config) => notificationApi.success(config),
    error: (config) => notificationApi.error(config),
    warning: (config) => notificationApi.warning(config),
    info: (config) => notificationApi.info(config),
    open: (config) => notificationApi.open(config),
    destroy: (key) => notificationApi.destroy(key),
  };

  return (
    <MessageContext.Provider
      value={{
        message: customMessage,
        notification: customNotification,
      }}
    >
      {messageContextHolder}
      {notificationContextHolder}
      {children}
    </MessageContext.Provider>
  );
};
